import { render } from "./VabeneDeletedOrders.vue?vue&type=template&id=6e054e4c&scoped=true&ts=true"
import script from "./VabeneDeletedOrders.vue?vue&type=script&lang=ts"
export * from "./VabeneDeletedOrders.vue?vue&type=script&lang=ts"

import "./VabeneDeletedOrders.vue?vue&type=style&index=0&id=6e054e4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e054e4c"]])

export default __exports__